var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Cup_Line",
    "data-name": "icons/Cup/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.666,
    height: 12,
    viewBox: "0 0 14.666 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.667,9.334A4.672,4.672,0,0,1,0,4.667V2A2,2,0,0,1,2,0H7.333a2,2,0,0,1,2,2V4.667A4.672,4.672,0,0,1,4.667,9.334ZM2,1.333A.667.667,0,0,0,1.333,2V4.667A3.333,3.333,0,0,0,8,4.667V2a.667.667,0,0,0-.667-.667Z",
    transform: "translate(2.667)",
    fill: "#fcfcfd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M12,5.333H10.667V0h2a2,2,0,0,1,2,2v.667A2.67,2.67,0,0,1,12,5.333Zm0-4V4a1.335,1.335,0,0,0,1.333-1.334V2a.667.667,0,0,0-.667-.667Zm-8,4H2.666A2.67,2.67,0,0,1,0,2.666V2A2,2,0,0,1,2,0H4V5.333Zm-2-4A.667.667,0,0,0,1.333,2v.667A1.335,1.335,0,0,0,2.666,4V1.333Z",
    transform: "translate(0 1.333)",
    fill: "#fcfcfd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M2,.667v2H.667A.667.667,0,1,0,.667,4h4a.667.667,0,0,0,0-1.333H3.333v-2A.667.667,0,0,0,2,.667Z",
    transform: "translate(4.667 8)",
    fill: "#fcfcfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.51d71246f36b7daa30fa1b4d54c53cc2.svg";
export { ForwardRef as ReactComponent };